/* GUNDERWEAR test: dynamic colors and native Shopify fixed Bundles; no relationship metafields. */
(function () {
  "use strict";

  function start() {
    var colorRoot = document.querySelector("[data-gw-dynamic-colors]");
    var packRoot = document.querySelector("[data-gw-dynamic-packs]");
    if (!colorRoot || !packRoot) return;

    var vendor = (colorRoot.dataset.vendor || "").trim();
    var mpn = (colorRoot.dataset.mpn || "").trim();
    var collection = (colorRoot.dataset.collection || "").trim();
    var handle = (colorRoot.dataset.handle || "").trim();
    var currentId = colorRoot.dataset.id || "";
    var currentStock = colorRoot.dataset.stock === "true";
    var currentIsMultipack = colorRoot.dataset.isMultipack === "true";
    // The parent bundle's native Shopify color-pattern references already
    // list the actual component colors. Keep single-product dots unchanged.
    var packColors = (colorRoot.dataset.packColors || "").split("|")
      .map(function (value) { return value.trim(); })
      .filter(function (hex) { return /^#[a-fA-F0-9]{3,8}$/.test(hex); })
      .slice(0, 24);

    var debugMode = new URLSearchParams(location.search).get("gw_debug") === "1";
    var debugPanel = null;

    function log(message) {
      if (!debugMode) return;
      if (!debugPanel) {
        debugPanel = document.createElement("div");
        debugPanel.style.cssText = "position:fixed;bottom:12px;left:12px;right:12px;z-index:2147483647;padding:10px 14px;background:#fff;color:#111;border:1px solid #777;border-radius:8px;box-shadow:0 2px 12px #0003;font:12px/1.5 Arial,sans-serif;max-height:25vh;overflow:auto";
        debugPanel.setAttribute("role", "status");
        document.body.appendChild(debugPanel);
      }
      var line = document.createElement("div");
      line.textContent = "GW TEST · " + message;
      debugPanel.appendChild(line);
    }

    function normalize(value) {
      return String(value == null ? "" : value).trim();
    }

    function productId(value) {
      return normalize(value).split("/").pop();
    }

    async function getIndexPage(page) {
      var url = new URL(colorRoot.dataset.searchUrl || "/search", location.origin);
      var queryVendor = vendor.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
      url.searchParams.set("q", 'vendor:"' + queryVendor + '"');
      url.searchParams.set("type", "product");
      url.searchParams.set("page", String(page));
      url.searchParams.set("options[unavailable_products]", "show");
      url.searchParams.set("options[prefix]", "none");
      url.searchParams.set("section_id", "gw-dynamic-index");

      var response = await fetch(url.toString(), {credentials:"same-origin", headers:{"Accept":"text/html"}});
      if (!response.ok) throw new Error("Zoeksectie HTTP " + response.status);
      var html = await response.text();
      var fragment = new DOMParser().parseFromString(html, "text/html");
      var script = fragment.querySelector("[data-gw-dynamic-index]");
      if (!script) throw new Error("Zoekindex ontbreekt in zoeksectie (zoekopdracht vendor)");
      var result = JSON.parse(script.textContent || "{}");
      if (!Array.isArray(result.items)) throw new Error("Zoekindex heeft geen producten");
      return result;
    }

    async function loadIndex() {
      if (!vendor) return [];
      var cacheKey = "gw-dynamic-v2:" + location.hostname + ":" + (colorRoot.dataset.searchUrl || "") + ":" + vendor.toLowerCase();
      try {
        var cached = JSON.parse(sessionStorage.getItem(cacheKey) || "null");
        if (cached && cached.at && Date.now() - cached.at < 45000 && Array.isArray(cached.products)) {
          log("Herbruikte actuele zoekindex: " + cached.products.length + " producten");
          return cached.products;
        }
      } catch (error) { /* Storage is optional. */ }

      var first = await getIndexPage(1);
      var pages = Math.min(Math.max(Number(first.pages) || 1, 1), 20);
      if (Number(first.pages) > 20) throw new Error("Meer dan 1.000 zoekresultaten; index is niet compleet");
      var products = first.items.slice();
      for (var begin = 2; begin <= pages; begin += 4) {
        var jobs = [];
        for (var i = begin; i < Math.min(begin + 4, pages + 1); i++) jobs.push(getIndexPage(i));
        var results = await Promise.all(jobs);
        results.forEach(function (page) { products.push.apply(products, page.items); });
      }
      products = products.filter(function (p) { return normalize(p.vendor).toLowerCase() === vendor.toLowerCase(); });
      try { sessionStorage.setItem(cacheKey, JSON.stringify({at:Date.now(),products:products})); } catch (error) { /* optional */ }
      log("Zoekindex " + vendor + ": " + products.length + " producten (" + pages + " pagina's)");
      return products;
    }

    function renderColors(products) {
      if (!mpn || !collection) {
        log("Kleuren: MPN of Collectie ontbreekt");
        return;
      }
      // Use the same MPN and collection as the existing color logic.
      // Available multipacks share the color row, but always follow single colors.
      var options = products.filter(function (p) {
        return normalize(p.mpn) === mpn &&
          normalize(p.collection) === collection &&
          p.inStock === true &&
          p.url;
      });
      if (currentStock && !options.some(function (p) { return productId(p.id) === currentId; })) {
        options.push({
          id:currentId,
          color:colorRoot.dataset.currentColor,
          hex:colorRoot.dataset.currentHex,
          title:colorRoot.dataset.currentTitle,
          url:colorRoot.dataset.currentUrl,
          inStock:true,
          isMultipack:currentIsMultipack,
          packColors:packColors
        });
      }
      options.sort(function (a,b) {
        if (Boolean(a.isMultipack) !== Boolean(b.isMultipack)) {
          return a.isMultipack ? 1 : -1;
        }
        return normalize(a.color || a.title).localeCompare(normalize(b.color || b.title));
      });
      log("Kleuren: " + options.length + " beschikbare varianten voor " + mpn + " / " + collection);
      if (options.length <= 1 && (options.length === 0 || currentStock)) return;

      colorRoot.querySelector(".gw-mpn-colors__heading").textContent =
        (colorRoot.dataset.heading || "Color") + ": " + (colorRoot.dataset.currentColor || "");
      var list = colorRoot.querySelector(".gw-mpn-colors__items");
      options.forEach(function (p) {
        var a = document.createElement("a");
        a.className = "gw-mpn-colors__swatch";
        var selected = productId(p.id) === currentId;
        if (selected) {
          a.classList.add("is-selected");
          a.setAttribute("aria-current", "page");
        }
        a.href = p.url;
        var color = normalize(p.color || p.title);
        var label = p.isMultipack ? normalize(p.title || color) : color;
        a.title = label;
        a.setAttribute("aria-label", label);
        var hex = normalize(p.hex);
        a.style.setProperty("--gw-mpn-swatch", /^#[a-fA-F0-9]{3,8}$/.test(hex) ? hex : "#dddddd");
        // Read each bundle's own native Shopify colors, including on single-product pages.
        // The current bundle also has a server-rendered fallback if the index is stale.
        var swatchColors = Array.isArray(p.packColors) ? p.packColors : [];
        if (selected && p.isMultipack && packColors.length) swatchColors = packColors;
        swatchColors = swatchColors.map(normalize).filter(function (value) {
          return /^#[a-fA-F0-9]{3,8}$/.test(value);
        });
        if (p.isMultipack && swatchColors.length > 1) {
          var segments = swatchColors.map(function (segmentColor, index) {
            var from = (index * 100 / swatchColors.length).toFixed(4);
            var to = ((index + 1) * 100 / swatchColors.length).toFixed(4);
            return segmentColor + " " + from + "% " + to + "%";
          });
          a.style.backgroundImage = "conic-gradient(" + segments.join(", ") + ")";
        }
        var hiddenText = document.createElement("span");
        hiddenText.className = "visually-hidden";
        hiddenText.textContent = label;
        a.appendChild(hiddenText);
        list.appendChild(a);
      });
      colorRoot.hidden = false;
    }

    var bundleQuery = "query GWGroupedBy($handle:String!,$after:String){ product(handle:$handle){variants(first:20,after:$after){nodes{groupedBy(first:15){nodes{product{id}}pageInfo{hasNextPage}}}pageInfo{hasNextPage endCursor}}}}";

    async function queryStorefront(variables) {
      var domain = colorRoot.dataset.shopDomain || "";
      var endpoints = [location.origin + "/api/2026-10/graphql.json"];
      if (/^[a-z0-9.-]+\.myshopify\.com$/i.test(domain)) {
        endpoints.push("https://" + domain + "/api/2026-10/graphql.json");
      }
      var lastError;
      for (var e = 0; e < endpoints.length; e++) {
        try {
          var response = await fetch(endpoints[e], {
            method:"POST", mode:"cors", credentials:"omit",
            headers:{"Content-Type":"application/json"},
            body:JSON.stringify({query:bundleQuery, variables:variables})
          });
          if (!response.ok) throw new Error("Storefront GraphQL HTTP " + response.status);
          var body = await response.json();
          if (body.errors && body.errors.length) {
            throw new Error("GraphQL: " + body.errors.map(function (x) { return x.message; }).join("; "));
          }
          if (!body.data) throw new Error("Storefront GraphQL geeft geen data");
          return body.data;
        } catch (error) {
          lastError = error;
        }
      }
      throw lastError || new Error("Geen toegang tot Storefront API");
    }

    async function loadBundleIds() {
      if (!handle) return [];
      var cursor = null;
      var ids = [];
      var seen = {};
      for (var page = 0; page < 5; page++) {
        var data = await queryStorefront({handle:handle,after:cursor});
        if (!data.product) {
          log("Product niet beschikbaar in Storefront API");
          return [];
        }
        var variants = data.product.variants;
        (variants.nodes || []).forEach(function (variant) {
          (variant.groupedBy && variant.groupedBy.nodes || []).forEach(function (bundleVariant) {
            if (bundleVariant.product && bundleVariant.product.id) {
              var id = productId(bundleVariant.product.id);
              if (!seen[id]) { seen[id]=true; ids.push(id); }
            }
          });
        });
        if (!variants.pageInfo || !variants.pageInfo.hasNextPage) break;
        cursor = variants.pageInfo.endCursor;
        if (!cursor) break;
      }
      log("Shopify Bundles: " + ids.length + " unieke parentproducten");
      return ids;
    }

    function renderPacks(products, ids) {
      var byId = new Map();
      products.forEach(function (p) { byId.set(productId(p.id), p); });
      var packProducts = ids.map(function (id) { return byId.get(id); })
        .filter(function (p) { return p && p.inStock === true && p.url; })
        .slice(0, 2);
      log("Multipacks: " + packProducts.length + " actuele aanbevelingen");
      if (!packProducts.length) return;
      var container = packRoot.querySelector(".gw-multipack__items");
      packProducts.forEach(function (p) {
        var a = document.createElement("a");
        a.className = "gw-multipack__item";
        a.href = p.url;
        var imgBox = document.createElement("span");
        imgBox.className = "gw-multipack__image";
        if (p.image) {
          var img = document.createElement("img");
          img.src = p.image;
          img.alt = normalize(p.title);
          img.loading = "lazy";
          imgBox.appendChild(img);
        }
        a.appendChild(imgBox);
        var content = document.createElement("span");
        content.className = "gw-multipack__content";
        var name = document.createElement("span");
        name.className = "gw-multipack__name";
        name.textContent = normalize(p.title);
        content.appendChild(name);
        var footer = document.createElement("span");
        footer.className = "gw-multipack__footer";
        var price = document.createElement("span");
        price.className = "gw-multipack__price";
        price.textContent = normalize(p.price);
        footer.appendChild(price);
        var cta = document.createElement("span");
        cta.className = "gw-multipack__action";
        cta.textContent = packRoot.dataset.cta || "View multipack";
        footer.appendChild(cta);
        content.appendChild(footer);
        a.appendChild(content);
        container.appendChild(a);
      });
      packRoot.hidden = false;
    }

    log("Start live zoekindex en Shopify Bundles");
    var indexPromise = loadIndex();
    var bundlePromise = loadBundleIds();
    indexPromise.then(renderColors).catch(function (error) {
      console.warn("[GUNDERWEAR Dynamic] Kleuren zoeken mislukt:", error);
      log("Kleuren fout: " + error.message);
    });
    Promise.all([indexPromise,bundlePromise]).then(function (values) {
      renderPacks(values[0], values[1]);
    }).catch(function (error) {
      console.warn("[GUNDERWEAR Dynamic] Multipacks zoeken mislukt:", error);
      log("Multipacks fout: " + error.message);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {once:true});
  } else {
    start();
  }
})();